// @ts-nocheck
import { useCompatQuery } from './useApolloCompat';
import { PAY_STUB_DETAIL_QUERY } from '../graphql/operations';

export function usePayStubDetail(id: string) {
  return useCompatQuery(PAY_STUB_DETAIL_QUERY, { variables: { id }, skip: !id });
}
